import api from "../core/http";

/**
 * All reading orders and readings related API calls
 */

/**
 * Get Reading orders list by type
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getPartnerReadingOrders = () => {
  return api
    .get(`/v1/partner/reading-orders`)
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get a single reading order
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getPartnerReadingOrder = (readingOrderId) => {
  return api
    .get(`/v1/partner/reading-orders/${readingOrderId}`)
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get comics order for a single reading order
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getPartnerReadingOrderComics = (readingOrderId) => {
  return api
    .get(`/v1/partner/reading-orders/${readingOrderId}/comics`)
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Update the reading order
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const updatePartnerReadingOrderComics = (readingOrderId, values) => {
  return api
    .post(`/v1/partner/reading-orders/${readingOrderId}/comics`, values)
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Get Comics list
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getPartnerComics = (
  franchise = null,
  searchTerm = null,
  sortBy = "id",
  sortByDirection = "desc"
) => {
  return api
    .get(`/v1/partner/comics`, {
      params: {
        searchTerm: encodeURIComponent(searchTerm),
        franchise,
        sortBy,
        sortByDirection,
      },
    })
    .then((res) => res.data)
    .catch((err) => err);
};

/**
 * Stats - readers progress
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getStatsProgress = () => {
  return api.get(`/v1/partners/stats/progress`);
};

/**
 * Stats - active readers
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getStatsActiveReaders = () => {
  return api.get(`/v1/partners/stats/active-readers`);
};

/**
 * Stats - figures
 * - uses react-query
 * @param {*} type
 * @returns
 */
export const getStatsFigures = () => {
  return api.get(`/v1/partners/stats/figures`);
};
